import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Form } from "@/components/ui/form";

import { ResendConnectionFields } from "./resend-connection-fields";
import { useResendConnectionForm } from "./use-resend-connection-form";

import type { ResendConnection } from "@artisancode/api-types";

export function ResendConnectionDialog({
  open,
  onOpenChange,
  editing,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  editing: ResendConnection | null;
}) {
  const { form, isSubmitting, onSubmit } = useResendConnectionForm(
    open,
    editing,
    () => onOpenChange(false),
  );

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-sm">
        <DialogHeader>
          <DialogTitle>
            {editing ? "Edit Koneksi Resend" : "Tambah Koneksi Resend"}
          </DialogTitle>
        </DialogHeader>
        <Form {...form}>
          <form
            id="resend-connection-form"
            onSubmit={onSubmit}
            className="py-2"
          >
            <ResendConnectionFields form={form} editing={editing} />
          </form>
        </Form>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isSubmitting}
          >
            Batal
          </Button>
          <Button
            type="submit"
            form="resend-connection-form"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Menyimpan..." : editing ? "Simpan" : "Tambah"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
